import { calculateWhenEnd } from '../../../helpers/interface_helpers';

export const parse_intervals_to_in_one_day_format = (
	interval: {
		indailyint: any;
		tschem_temp?: number;
	},
	type: 'scene_active_time' | 'temp_scheme_intervals',
) => {
	let interval_days = interval.indailyint.dows.split(' ').map((e) => Number(e));

	let [startHourInd = 0, startMinInd = 0] = interval.indailyint.startat
		.split(':')
		.map((el) => Number(el));

	let end = calculateWhenEnd(interval.indailyint.startat, interval.indailyint.dur);

	let [endHourInd = 23, endMinInd = 59] = end.split(':').map((e) => Number(e));

	let returned = {};
	let base_for_interval_type = type === 'temp_scheme_intervals' ? interval?.tschem_temp : 'X';

	interval_days.forEach((day) => {
		if (returned[day] === undefined) {
			returned[day] = [];
		}
		if (startHourInd > endHourInd) {
			//in two days interval
			//ex: 23:23 = 03:03
			returned[day].push({
				startHourInd,
				startMinInd,
				endHourInd: 23,
				endMinInd: 59,
				base: base_for_interval_type,
			});

			let nextDay = day + 1 <= 7 ? day + 1 : 1;
			if (returned[nextDay] === undefined) returned[nextDay] = [];
			returned[nextDay].push({
				startHourInd: 0,
				startMinInd: 0,
				endHourInd,
				endMinInd,
				base: base_for_interval_type,
			});
		} else {
			//in one day interval
			returned[day].push({
				startHourInd,
				startMinInd,
				endHourInd,
				endMinInd,
				base: base_for_interval_type,
			});
		}
	});
	// console.log(JSON.stringify(returned, null, 2));

	return returned;
};

export const fillIntervalMatrix = (intervals, type: 'scene_active_time' | 'temp_scheme_intervals') => {
	let intervalMatrix = {
		1: {},
		2: {},
		3: {},
		4: {},
		5: {},
		6: {},
		7: {},
	};
	for (let key in intervalMatrix) {
		for (let i = 0; i < 24; i++) {
			intervalMatrix[key][i] = new Array(60).fill(null);
		}
	}
	//console.log('object keys ', Object.keys(intervalMatrix));

	for (let interval of intervals) {
		//   console.log('interval ', interval);
		interval.indailyint.dows = interval.indailyint.dows.trimEnd();

		let intervals_by_days = parse_intervals_to_in_one_day_format(interval, type);

		//   console.log('intervals by days ', JSON.stringify(intervals_by_days));

		for (let entity of Object.entries(intervals_by_days)) {
			let day = entity[0];
			//  console.log(day);
			let inDaysIntervals: any = entity[1];
			//   console.log('intervals array for day ', inDaysIntervals);
			for (let day_interval of inDaysIntervals) {
				let {
					startHourInd = 0,
					startMinInd = 0,
					endHourInd = 23,
					endMinInd = 59,
					base = null,
				} = day_interval;

				for (let hour = startHourInd; hour <= endHourInd; hour++) {
					// console.log('is started hour ', hour === startHourInd);
					// console.log(' is ended hour ', hour === endHourInd);
					//check if it is an interval with duration more than hour
					if (startHourInd === endHourInd) {
						for (let min = startMinInd; min <= endMinInd; min++) {
							intervalMatrix[day][hour][min] = base;
						}
					} else if (hour === startHourInd) {
						// console.log('started hour start from ', startMinInd);
						for (let min = startMinInd; min <= 59; min++) {
							intervalMatrix[day][hour][min] = base;
						}
					} else if (hour === endHourInd) {
						// console.log('end time max elements in last hour ', endMinInd);
						for (let min = 0; min <= endMinInd; min++) {
							intervalMatrix[day][hour][min] = base;
						}
					} else {
						// console.log('in between cover whole hour 0-59');
						for (let min = 0; min <= 59; min++) {
							intervalMatrix[day][hour][min] = base;
						}
					}
				}

				// console.warn('UPDATED DAY ', JSON.stringify(intervalMatrix[day]));
			}
		}
	}

	return intervalMatrix;
};

export const findEmptyIntervals = (intervalMatrix) => {
	let emptyHoursForWeek = {};

	for (let day in intervalMatrix) {
		emptyHoursForWeek[day] = [];
		let hoursObj = intervalMatrix[day];
		// console.log(hoursObj);
		let startTime = [];
		let endTime = [];
		for (let hour in hoursObj) {
			for (let min = 0; min < 60; min++) {
				if (hoursObj[hour][min] === null) {
					if (startTime.length === 0) {
						startTime.push([hour, min]);
						// console.log('Start time ', hour, min);
					}
				} else {
					if (startTime.length === 1 && endTime.length === 0) {
						endTime.push([hour, min]);
						// console.log('end time ', hour, min);
					}
				}

				if (
					Number(hour) === 23 &&
					min === 59 &&
					startTime.length === 1 &&
					endTime.length === 0
				) {
					// console.log('end time ', hour, min);
					endTime.push([hour, min]);

					if (startTime[0] === endTime[0] && startTime[1] === endTime[1]) {
						startTime = [];
						endTime = [];
					}
				}
			}
			//if there is start and end time durinf the hour save them
			if (startTime.length === 1 && endTime.length === 1) {
				emptyHoursForWeek[day].push([{ start: [...startTime], end: [...endTime] }]);

				startTime = [];
				endTime = [];
			}
		}
		//if there are an empty interval with length more then hour
		// console.log(startTime.length, endTime.length);
		if (startTime.length === 1 && endTime.length === 1) {
			emptyHoursForWeek[day].push([{ start: [...startTime], end: [...endTime] }]);

			startTime = [];
			endTime = [];
		}
	}
	// console.log(emptyHoursForWeek);

	return emptyHoursForWeek;
};

export const extractEmptyInterval = (emptyIntervals) => {
	let isin = [];
	let time = {
		start: [0, 0],
		end: [23, 59],
	};

	for (let day_intervals of Object.entries(emptyIntervals)) {
		let [day, intervals] = day_intervals;
		// console.log(day, intervals);
		let maxInervalsPerDay = 0;

		(intervals as any).forEach((interval) => {
			if (interval.length > maxInervalsPerDay) {
				maxInervalsPerDay = interval.length;
			}
		});

		for (let i = 0; i < maxInervalsPerDay; i++) {
			let interval = intervals[i][0];

			// 23:23 => 2323
			// console.log('each interval ', interval);

			let start_empty_interval_as_num: number = Number(
				`${Number(time.start[0]) < 10 ? '0' + time.start[0] : time.start[0]}${
					Number(time.start[1]) < 10 ? '0' + time.start[1] : time.start[1]
				}`,
			);
			// console.log(
			// 	Number(time.start[0]) < 10 ? '0' + time.start[0] : time.start[0]
			// );
			// console.log(
			// 	Number(time.start[1]) < 10 ? '0' + time.start[1] : time.start[1]
			// );
			let end_empty_interval_as_num: number = Number(
				`${Number(time.end[0]) < 10 ? '0' + time.end[0] : time.end[0]}${
					Number(time.end[1]) < 10 ? '0' + time.end[1] : time.end[1]
				}`,
			);

			let start_at_ind_interval_as_num: number = Number(
				`${Number(interval.start[0][0]) < 10 ? '0' + interval.start[0][0] : interval.start[0][0]}${
					Number(interval.start[0][1]) < 10 ? '0' + interval.start[0][1] : interval.start[0][1]
				}`,
			);
			let end_at_ind_interval_as_num: number = Number(
				`${Number(interval.end[0][0]) < 10 ? '0' + interval.end[0][0] : interval.end[0][0]}${
					Number(interval.end[0][1]) < 10 ? '0' + interval.end[0][1] : interval.end[0][1]
				}`,
			);

			// console.log(start_empty_interval_as_num);
			// console.log(end_empty_interval_as_num);
			// console.log(start_at_ind_interval_as_num);
			// console.log(end_at_ind_interval_as_num);
			if (start_empty_interval_as_num < start_at_ind_interval_as_num) {
				//22:34 -23:40 -> 23:33 -> 23:59
				//22: 34 - 23:40 -> 23:33 -> 23:35
				//1. ovverride start time with current el start time 23:23
				// 2. check end time and get the lower value

				// 20:20 - 20: 50 -> 20:30 - 21:50
				// 20:20 -> 20: 50 -> 20: 33 -> 20: 53
				// 20:20 -> 20: 50 -> 20: 33 -> 20: 49
				time.start = [interval.start[0][0], interval.start[0][1]];
				time.end =
					// the first check is about that case
					// end_empty_interval_as_num 00:00 - 13:14
					//start_at_ind_interval_as_num 22:01 - 23:59
					end_empty_interval_as_num <= start_at_ind_interval_as_num
						? [interval.end[0][0], interval.end[0][1]]
						: end_empty_interval_as_num < end_at_ind_interval_as_num
							? [...time.end]
							: [interval.end[0][0], interval.end[0][1]];
				if (!isin.includes((day) => Number(day - 1))) {
					isin.push(Number(day) - 1);
				}
			} else if (start_empty_interval_as_num === start_at_ind_interval_as_num) {
				//20:44 - 21: 50 -> 20:44 - 22:00
				// 20:00 - 22:00 -> 20:00 - 20:30
				time.start = [...time.start];
				time.end =
					end_empty_interval_as_num < end_at_ind_interval_as_num
						? [...time.end]
						: [interval.end[0][0], interval.end[0][1]];
				if (!isin.includes((day) => Number(day - 1))) {
					isin.push(Number(day) - 1);
				}
				// because start time for both intervals is equal no need to ovverride it
			} else {
				// текущия старт час е по-голям от този на интервала
				// 05:55 - 23:59 -> 00:00 -> 23:59 - > вземаме 5:55 -> 23:59
				// 05:55 - 23:59 -> 00:00 -> 12:00 -> 5:55 -12:00
				// 05:55 - 23:59 -> 00: 00 -> 05:55 -> махаме деня
				// 05:55 - 23:59 -> 00: 00 -> 05:53-> махаме деня
				// 05:56 - 23: 23 -> 00:00 -> 23:59

				if (end_at_ind_interval_as_num <= start_empty_interval_as_num) {
					//skip time interval re-wrute execlude day from the array
					// it is invalid format fot the day
					if (isin.includes((day) => Number(day - 1))) {
						isin = [...isin.filter((el) => el !== Number(day) - 1)];
					}
				} else {
					time.start = [...time.start];
					time.end =
						end_empty_interval_as_num <= end_at_ind_interval_as_num
							? [...time.end]
							: [interval.end[0][0], interval.end[0][1]];
					if (!isin.includes((day) => Number(day - 1))) {
						isin.push(Number(day) - 1);
					}
				}
			}
		}
	}

	// console.log('isin ', isin);
	// console.log('interval ', time);
	return {
		isin,
		time: [
			`${time.start[0] < 10 ? '0' + time.start[0] : time.start[0]}:${
				time.start[1] < 10 ? '0' + time.start[1] : time.start[1]
			}`,
			`${time.end[0] < 10 ? '0' + time.end[0] : time.end[0]}:${
				time.end[1] < 10 ? '0' + time.end[1] : time.end[1]
			}`,
		],
	};
};
